export default __webpack_public_path__ + "static/media/dependents-icon.0ba0f755.svg";